import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as core from '../../core'

// TODO: JSDocs

export interface ChangeHistory {
  events: readonly ChangeHistory.Event[]
  latestEvent?: ChangeHistory.Event
}
export namespace ChangeHistory {
  export interface Event {
    type: Event.Type
    user: core.admin.User
    timestamp: Date
  }
  export namespace Event {
    export enum Type {
      Created = 'created',
      Updated = 'updated',
      Deleted = 'deleted',
    }
    // Needs to be before namespace is defined
    const TYPES: ReadonlySet<Type> = new Set(Object.values(Type) as Type[])
    export namespace Type {
      export const ALL: readonly Type[] = Array.from(TYPES)
      export const isType = TypeChecker.Factory.oneOf(TYPES)
      export const assertIsType: TypeAsserter<Type> =
        TypeAsserter.Factory.from(isType)
    }
  }
}
